<template>
  <v-row >
    <v-col cols="12" sm="12" md="2" class="pa-2 left-column">
      <v-card class="teams-card">
        <v-card-text class="pa-2">
          <v-text-field
            v-model="listSearchQuery"
            :label="$t('searchTeams')"
            hide-details
            density="compact"
            variant="outlined"
            prepend-inner-icon="mdi-magnify"
            class="mb-2"
          ></v-text-field>
        </v-card-text>
        <v-expansion-panels v-model="openPanels" multiple>
          <v-expansion-panel v-for="(profileTeams, profile) in filteredGroupedTeams"
                            :key="profile"
                            class="team-panel">
            <v-expansion-panel-title density="compact">
              <span class="text-subtitle-2">{{ profile }}</span>
              <template v-slot:actions>
                <v-chip size="small" color="primary" text-color="white">
                  {{ getTotalProfileCount(profileTeams) }}
                </v-chip>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-list v-model:selected="selectedTeam" density="compact">
                <v-list-item v-for="team in profileTeams"
                            :key="team.id"
                            :value="team.id"
                            @click="selectTeamInFilterContext(team.id)"
                            class="team-list-item">
                  <v-list-item-title class="text-body-2">{{ team.name }}</v-list-item-title>
                  <template v-slot:append>
                    <v-chip size="small" text-color="white">
                      {{ getOriginalTeamCount(team.id) }}
                    </v-chip>
                  </template>
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-col>

    <v-divider vertical class="d-none d-md-flex" />

    <v-col cols="12" md="10" class="pa-2 right-column">
      <v-sheet elevation="2" rounded class="mb-4 pa-4">
        <v-row no-gutters align="center">
          <v-col cols="12" sm="6" md="4" class="d-flex align-center">
            <v-btn
              class="mr-2"
              :disabled="selectedSubItems.length === 0"
              prepend-icon="mdi-account-multiple-outline"
              variant="outlined"
              @click="openAssignmentDialog"
              density="comfortable"
            >
              {{ $t('assign', { count: selectedSubItems.length }) }}
            </v-btn>
            <v-tooltip v-if="selectedTeam[0] !== t('unAssigned')" :text="$t('tooltips.selectUnassigned')" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn variant="text" v-bind="props" @click="selectUnassignedUsers" density="comfortable">
                  <v-icon>mdi-account-multiple-plus</v-icon>
                </v-btn>
              </template>
            </v-tooltip>

            <v-tooltip :text="$t('tooltips.selectAll')" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn variant="text" v-bind="props" @click="selectAll" density="comfortable">
                  <v-icon>mdi-select-all</v-icon>
                </v-btn>
              </template>
            </v-tooltip>

            <v-tooltip :text="$t('tooltips.deselectAll')" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn variant="text" v-bind="props" @click="deselectAll" density="comfortable">
                  <v-icon>mdi-select-off</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="8" class="d-flex justify-end">
            <v-text-field
              v-model="searchQuery"
              :label="$t('search')"
              hide-details
              density="compact"
              variant="outlined"
              prepend-inner-icon="mdi-magnify"
              class="search-field"
              style="max-width: 300px;"
              @update:model-value="filterItems"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet elevation="2" rounded class="pa-4">
        <v-data-table
          v-model="selectedSubItems"
          :headers="headers"
          :items="filteredItems"
          item-value="subItems[0].id"
          show-select
          class="elevation-0"
          :sort-by="[{ key: 'itemUpdated', order: 'desc' }]"
          :expanded="expanded"
          item-key="id"
          :expand-on-click="false"
          :locale="$i18n.locale"
          :no-data-text="$t('noData')"
          :items-per-page-text="$t('itemsPerPage')"
          :hide-headers="isMobile"
          >

          <!-- Mobile Layout -->
          <template v-if="isMobile" v-slot:item="{ item }">
            <tr>
              <td>
            <v-card class="mb-2" variant="flat">
              <v-card-title class="d-flex justify-space-between align-center">
                <v-checkbox
              v-if="item.subItems.length === 1"
              v-model="selectedSubItems"
              :value="item.subItems[0].id"
              hide-details
              class="mr-2"
            ></v-checkbox>
                <v-chip label variant="text">
                  <v-icon v-bind="getIconClass(categoriesObj[itemTemplatesObj[item.profileId].categoryId].icon)" class="mr-2"></v-icon>
                  <a @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/${item.type === 'IssueTemplate' ? 'issues?issue' : 'processes?process'}-client-ids=${item.clientId}&subcategory-ids=${itemTemplatesObj[item.profileId].subcategoryId}`)"
                    href="#"
                    style="color: inherit;">
                    {{ item.clientId }}
                  </a>
                </v-chip>
                <v-chip                                     
                  :style="{
                    backgroundColor: statusTemplatesObj[item.subItems[0].statusId].color,
                    color: 'white',
                    marginTop:'5px'
                  }" 
                  label
                >
                  {{ statusTemplatesObj[item.subItems[0].statusId].title }}
                </v-chip>
              </v-card-title>

              <v-card-text>
                <div class="mb-2 text-h6">
                  {{ itemTemplatesObj[item.profileId].title }}
                </div>

                <div v-if="item.subItems.length === 1" class="mb-2 d-flex justify-space-between">
                  <strong style="flex-shrink: 0">{{ $t('assignedTo') }}:</strong>
                  <div class="d-flex flex-column align-end">
                    <span>{{ item.subItems[0].assigneeTeamId ? teamsObj[item.subItems[0].assigneeTeamId].name : '-' }}</span>
                    <div class="d-flex justify-end mt-1">
                      <template v-if="item.subItems[0].assigneeUserIds.length > 0">                   
                        <v-avatar
                          v-for="userId in item.subItems[0].assigneeUserIds.slice(0, 3)"
                          :key="userId"
                          size="28"
                          class="mr-1"
                        >
                          <v-img
                            v-if="usersObj[userId]?.avatarUrl"
                            :src="'https://' + usersObj[userId].avatarUrl"
                            alt="User Avatar"
                          ></v-img>
                          <span
                            v-else
                            class="d-flex justify-center align-center text-caption white--text"
                            :style="{
                              backgroundColor: getRandomColor(userId),
                              width: '100%',
                              height: '100%',
                              borderRadius: '50%'
                            }"
                          >
                            {{ getInitials(usersObj[userId]?.displayName || '') }}
                          </span>
                        </v-avatar>
                        <span v-if="item.subItems[0].assigneeUserIds.length > 3" class="ml-1">
                          +{{ item.subItems[0].assigneeUserIds.length - 3 }}
                        </span>
                      </template>
                    </div>
                  </div>
                </div>

                <div class="mb-2 d-flex justify-space-between">
                  <strong style="flex-shrink: 0">{{ $t('location') }}:</strong>
                  <div class="d-flex flex-column align-end" style="max-width: calc(100% - 80px);">
                    <div class="w-100 d-flex justify-end">
                      <div class="d-flex align-start text-right">
                        <v-icon icon="mdi-map" size="small" class="flex-shrink-0 mr-1 mt-1"></v-icon>
                        <a @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/plan-viewer/${locationsObj[item.locationId].drawingId}`)"
                          href="#"
                          style="color: inherit;">
                          {{ locationsObj[item.locationId].drawingTitle }}
                        </a>
                      </div>
                    </div>
                    <div class="w-100 d-flex justify-end mt-1">
                      <div class="d-flex align-start text-right">
                        <v-icon icon="mdi-map-marker" size="small" class="flex-shrink-0 mr-1 mt-1"></v-icon>
                        <a @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/plan-viewer/${locationsObj[item.locationId].drawingId}#view/location${locationsObj[item.locationId].id}`)"
                          href="#"
                          style="color: inherit;">
                          {{ locationsObj[item.locationId].title }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-2 d-flex justify-space-between">
                  <strong style="flex-shrink: 0">{{ $t('updatedDate') }}:</strong>
                  <div class="d-flex align-center" :style="{
                    'text-align': item.subItems.length > 1 ? 'center' : 'right',
                    'justify-content': item.subItems.length > 1 ? 'center' : 'flex-end'
                  }">
                    {{ formatDate(item.subItems[0].statusCreatedDate) }}
                    <template v-if="item.subItems.length > 1">
                      <v-btn
                        class="ml-2"
                        prepend-icon="mdi-file-document-outline"
                        :text="item.subItems.length.toString()"
                        variant="outlined"
                        @click="showSubItemsDialog = true; selectedSubItems = item"
                      ></v-btn>
                    </template>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            </td>
            </tr>
          </template>
          <!-- Desktop mode-->
          <template v-else v-slot:item="{ item, columns }">
            <tr>
              <td class="client-id-cell">
                <div class="d-flex align-center">
                  <template v-if="item.subItems.length > 1">
                    <v-btn
                      :icon="expandIcon(item)"
                      @click="toggleExpand(item)"
                      variant="plain"
                      class="mr-2"
                    ></v-btn>
                  </template>
                  <v-checkbox
                    v-if="item.subItems.length === 1"
                    v-model="selectedSubItems"
                    :value="item.subItems[0].id"
                    hide-details
                    class="mr-2"
                  ></v-checkbox>
                  <v-chip label variant="text">
                    <v-icon v-bind="getIconClass(categoriesObj[itemTemplatesObj[item.profileId].categoryId].icon)" class="mr-2"></v-icon>
                    <a 
                      @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/${item.type === 'IssueTemplate' ? 'issues?issue' : 'processes?process'}-client-ids=${item.clientId}&subcategory-ids=${itemTemplatesObj[item.profileId].subcategoryId}`)"
                      href="#"
                      style="color: inherit;"
                    >
                      {{ item.clientId }}
                    </a>
                  </v-chip>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column align-start">
                  <template v-if="item.subItems.length === 1">
                    <span class="text-start">{{ itemTemplatesObj[item.profileId].title }}</span>
                    <span style="color: #888;" class="text-start text-caption">
                      {{ getFormTemplateTitleIfDifferent(item.subItems[0].itemTemplateId, item.profileId) }}
                    </span>
                  </template>
                  <template v-else>
                    <span class="text-start">{{ itemTemplatesObj[item.profileId].title }}</span>
                  </template>
                </div>
              </td>
              <td>
                <div class="d-flex align-center">
                  <template v-if="hasAssignees(item)">
                    <v-tooltip
                      v-for="userId in getUniqueAssigneeUserIds(item)"
                      :key="userId"
                      :text="usersObj[userId] ? usersObj[userId].displayName : $t('unknownUser')"
                      location="bottom"
                    >
                      <template v-slot:activator="{ props }">
                        <v-avatar v-bind="props" :size="28" class="mr-1">
                          <v-img
                            v-if="usersObj[userId] && usersObj[userId].avatarUrl"
                            :src="'https://' + usersObj[userId].avatarUrl"
                            alt="User Avatar"
                          ></v-img>
                          <span
                            v-else
                            class="d-flex justify-center align-center text-caption white--text"
                            :style="{
                              backgroundColor: getRandomColor(userId),
                              width: '100%',
                              height: '100%',
                              borderRadius: '50%'
                            }"
                          >
                            {{ getInitials(usersObj[userId] ? usersObj[userId].displayName : '') }}
                          </span>
                        </v-avatar>
                      </template>
                    </v-tooltip>
                    <span v-if="getUniqueAssigneeUserIds(item).length > 5" class="ml-1">
                      +{{ getUniqueAssigneeUserIds(item).length - 5 }}
                    </span>
                  </template>
                  <span v-else>-</span>
                </div>
              </td>
              <td>
                <div>
                  <v-icon icon="mdi-map" size="small" class="mr-1"></v-icon>
                  <a
                    @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/plan-viewer/${locationsObj[item.locationId].drawingId}`)"               
                    href="#"
                    style="color: inherit;"
                  >
                    {{ locationsObj[item.locationId].drawingTitle }}
                  </a>
                </div>
                <div>
                  <v-icon icon="mdi-map-marker" size="small" class="mr-1"></v-icon>
                  <a 
                    @click.prevent="openUrl(`https://${settings.apiUrl.startsWith('api-') ? settings.apiUrl.slice(4) : settings.apiUrl}/${settings.projectCode}/plan-viewer/${locationsObj[item.locationId].drawingId}#view/location${locationsObj[item.locationId].id}`)"
                    href="#"
                    style="color: inherit;"
                  >
                    {{ locationsObj[item.locationId].title }}
                  </a>
                </div>
              </td>
              <td>{{ formatDate(item.subItems[0].statusCreatedDate) }}</td>
              <td>
                <v-chip
                  :style="{
                    backgroundColor: statusTemplatesObj[item.subItems[0].statusId].color,
                    color: 'white'
                  }"
                  label
                        class="v-chipStatus"
                >
                  {{ statusTemplatesObj[item.subItems[0].statusId].title }}
                </v-chip>
              </td>
            </tr>
            <tr v-if="isExpanded(item) && item.subItems.length > 1">
              <td :colspan="columns.length">
                <v-data-table
                  v-model="selectedSubItems"
                  :headers="[
                    { title: $t('headers.subItem'), key: 'itemTemplateId', align: 'start', sortable: true },
                    { title: $t('headers.assignedTo'), key: 'assigneeUserIds', align: 'start', sortable: false },
                    { title: $t('headers.updatedDate'), key: 'updatedDate', align: 'start', sortable: true },
                    { title: $t('headers.status'), key: 'statusId', align: 'start', sortable: true }
                  ]"
                  :items="item.subItems"
                  item-value="id"
                  show-select
                  hide-default-footer
                  class="elevation-0"
                >
                  <template #[`item.itemTemplateId`]="{ item: subItem }">
                    {{ getFormTemplateTitle(subItem.itemTemplateId) }}
                  </template>

                  <template #[`item.assigneeUserIds`]="{ item: subItem }">
                    <div class="d-flex align-center">
                      <template v-if="subItem.assigneeUserIds.length > 0">
                        <v-tooltip
                          v-for="userId in subItem.assigneeUserIds.slice(0, 5)"
                          :key="userId"
                          :text="usersObj[userId] ? usersObj[userId].displayName : $t('unknownUser')"
                          location="bottom"
                        >
                          <template v-slot:activator="{ props }">
                            <v-avatar v-bind="props" :size="28" class="mr-1">
                              <v-img
                                v-if="usersObj[userId] && usersObj[userId].avatarUrl"
                                :src="'https://' + usersObj[userId].avatarUrl"
                                alt="User Avatar"
                              ></v-img>
                              <span
                                v-else
                                class="d-flex justify-center align-center text-caption white--text"
                                :style="{
                                  backgroundColor: getRandomColor(userId),
                                  width: '100%',
                                  height: '100%',
                                  borderRadius: '50%'
                                }"
                              >
                                {{ getInitials(usersObj[userId] ? usersObj[userId].displayName : '') }}
                              </span>
                            </v-avatar>
                          </template>
                        </v-tooltip>
                        <span v-if="subItem.assigneeUserIds.length > 5" class="ml-1">
                          +{{ subItem.assigneeUserIds.length - 5 }}
                        </span>
                      </template>
                      <span v-else>-</span>
                    </div>
                  </template>

                  <template #[`item.updatedDate`]="{ item: subItem }">
                    {{ formatDate(subItem.statusCreatedDate) }}
                  </template>

                  <template #[`item.statusId`]="{ item: subItem }">
                    <v-chip
                      :style="{
                        backgroundColor: statusTemplatesObj[subItem.statusId].color,
                        color: 'white'
                      }"
                      label
                    >
                      {{ statusTemplatesObj[subItem.statusId].title }}
                    </v-chip>
                  </template>
                </v-data-table>
              </td>
            </tr>
          </template>
          <template v-slot:headers="{}">
            <tr v-if="!isMobile">
              <th v-for="header in headers" :key="header.key">
                {{ header.title }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-sheet>
    </v-col>
  </v-row>
  <TeamAssignmentDialog
    v-model:dialog="showAssignmentDialog"
    v-model:selectedSubItems="selectedSubItems"
    v-model:selectedTeam="selectedTeam"
    @assign="handleAssign"
  />
</template>

<script setup>
import { ref, computed, watch, onMounted, defineProps, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify'
import { format } from 'date-fns';
import TeamAssignmentDialog from './TeamAssignmentDialog.vue';

const props = defineProps({
  assignableTeamIds: {
    type: Object,
    required: true
  }
});

const store = useStore();
const { t } = useI18n();
const settings = computed(() => store.state.settings);
const buildMode = computed(() => store.state.buildMode);
const { mobile, mdAndUp } = useDisplay()
const isMobile = computed(() => mobile.value && !mdAndUp.value)

const openPanels = ref([]); 


const categoriesObj = computed(() => store.getters.getCategoriesObj);
const itemTemplatesObj = computed(() => store.getters.getItemTemplatesObj);
const formTemplatesObj = computed(() => store.getters.getFormTemplatesObj);
const locationsObj = computed(() => store.getters.getLocationsObj);
const statusTemplatesObj = computed(() => store.getters.getStatusTemplatesObj);
const teamsObj = computed(() => store.getters.getTeamsObj);
const usersObj = computed(() => store.getters.getUsersObj);
const selectedSubItems = ref([]);
const expanded = ref([]);
const selectedTeam = ref([t('unAssigned')]);

const items = computed(() => store.getters.getItems);
const filterContext = computed(() => store.state.filterItemsContext);

const searchQuery = ref('');
const listSearchQuery = ref('');

const showAssignmentDialog = ref(false);

const headers = computed(() => {
  const baseHeaders = [
    { title: t('id'), key: 'clientId', align: 'start', sortable: true },
    { title: t('item'), key: 'profile', align: 'start', sortable: true },
    { title: t('assignedTo'), key: 'assignees', sortable: false },
    { title: t('location'), key: 'location', align: 'start', sortable: true },
    { title: t('updatedDate'), key: 'updatedDate', align: 'start', sortable: true },
    { title: t('status'), key: 'status', align: 'start', sortable: true },
  ];

  return baseHeaders;
});

const filteredItems = computed(() => {

  let filtered = filterContext.value.filteredItems.map(item => ({
    ...item,
    subItems: item.subItems.filter(subItem => {

      // Filter out subItems where assigneeTeamId doesn't exist in assignableTeamIds
      if (!props.assignableTeamIds[subItem.assigneeTeamId]) {
        return false;
      }

      // Apply search query
      if (searchQuery.value) {
        const search = searchQuery.value.toLowerCase();
        const itemValues = Object.values(item).concat(Object.values(subItem));
        const matchesSearch = itemValues.some(value => String(value).toLowerCase().includes(search))
          || itemTemplatesObj.value[item.profileId].title.toLowerCase().includes(search)
          || locationsObj.value[item.locationId].drawingTitle.toLowerCase().includes(search)
          || locationsObj.value[item.locationId].title.toLowerCase().includes(search)
          || statusTemplatesObj.value[subItem.statusId].title.toLowerCase().includes(search)
          || subItem.assigneeUserIds.some(userId => 
              usersObj.value[userId] && 
              usersObj.value[userId].displayName.toLowerCase().includes(search)
            )
          || (subItem.assigneeTeamId && (teamsObj.value[subItem.assigneeTeamId]?.name.toLowerCase().includes(search) ?? false));

        if (!matchesSearch) {
          return false;
        }
      }
      return true;
    })
  }));

  // Remove items with empty subItems array
  filtered = filtered.filter(item => item.subItems.length > 0);

  // Map the filtered items to include the computed properties
  return filtered.map(item => {
    const mappedItem = {
      ...item,
      itemTitle: itemTemplatesObj.value[item.profileId].title,
      itemDrawingLocation: locationsObj.value[item.locationId].drawingTitle,
      itemLocation: locationsObj.value[item.locationId].title,
      subItems: item.subItems.map(subItem => ({
        ...subItem,
        itemUpdated: subItem.statusCreatedDate,
        itemStatus: statusTemplatesObj.value[subItem.statusId].title,
        itemUser: selectedTeam.value[0] !== t('unAssigned') && subItem.assigneeTeamId ? teamsObj.value[subItem.assigneeTeamId].name : ''
      }))
    };

    return mappedItem;
  });
});

const groupedTeams = computed(() => {
  const grouped = {};
  if (teamsObj.value) {
    Object.values(teamsObj.value).forEach(team => {
      if (props.assignableTeamIds[team.id]) {
        if (!grouped[team.teamProfileTitle]) {
          grouped[team.teamProfileTitle] = [];
        }
        grouped[team.teamProfileTitle].push(team);
      }
    });
  }
  return grouped;
});

const filteredGroupedTeams = computed(() => {
  const filtered = {};
  for (const [profile, teams] of Object.entries(groupedTeams.value)) {
    const filteredTeams = teams.filter(team => {
      const teamItemCount = getOriginalTeamCount(team.id);
      const matchesSearch = !listSearchQuery.value || 
        team.name.toLowerCase().includes(listSearchQuery.value.toLowerCase());
      return teamItemCount > 0 && matchesSearch;
    });
    
    if (filteredTeams.length > 0 || 
        (profile.toLowerCase().includes(listSearchQuery.value.toLowerCase()))) {
      filtered[profile] = filteredTeams;
    }
  }
  return filtered;
});

const selectAll = () => {
  selectedSubItems.value = filteredItems.value.flatMap(item => 
    item.subItems.map(subItem => subItem.id)
  );
};

const selectUnassignedUsers = () => {
  if (selectedTeam.value[0] === t('unAssigned')) return;

  const unassignedSubItemIds = filteredItems.value.flatMap(item => 
    item.subItems
      .filter(subItem => subItem.assigneeUserIds.length === 0)
      .map(subItem => subItem.id)
  );
  
  selectedSubItems.value = [...new Set([...selectedSubItems.value, ...unassignedSubItemIds])];
};

const deselectAll = () => {
  selectedSubItems.value = [];
};

const getInitials = (name) => {
  if (!name) return '';
  const words = name.split(' ');
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  } else {
    return words[0].substring(0, 2).toUpperCase();
  }
};

const getFormTemplateTitleIfDifferent = (subItemTemplateId, itemProfileId) => {
  const formTemplate = formTemplatesObj.value[subItemTemplateId];
  if (!formTemplate) {
    return ''; // Must be an issue template
  }

  const itemProfile = itemTemplatesObj.value[itemProfileId];
  if (!itemProfile) {
    return 'Item Profile does not exist';
  }

  return formTemplate.title !== itemProfile.title ? formTemplate.title : '';
};

const getFormTemplateTitle = (subItemTemplateId) => {
  const formTemplate = formTemplatesObj.value[subItemTemplateId];
  if (formTemplate) {
    return formTemplate.title;
  }
  return '';
};


const getRandomColor = (id) => {
  const colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107', '#FF9800', '#FF5722'];
  
  if (!id) {
    return colors[Math.floor(Math.random() * colors.length)];
  }
  
  const index = id.toString().split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  return colors[index];
};

const getOriginalTeamCount = (teamId) => {
  return teamCount.value[teamId]?.originalCount || 0;
};

const selectTeamInFilterContext = (teamId) => {

  selectedTeam.value = [teamId];
  let ids = {};
  if (teamId === t('unAssigned')) {
    items.value.forEach(item => {
      item.subItems.forEach(subItem => {
        if (!subItem.assigneeTeamId) {
          ids[subItem.id] = true;
        }
      });
    });
  } else {
    items.value.forEach(item => {
      item.subItems.forEach(subItem => {
        if (subItem.assigneeTeamId === teamId) {
          ids[subItem.id] = true;
        }
      });
    });
  }

  store.commit('updateFilter', {chartId:'teamList', ids:ids});
};


const getTotalProfileCount = (profileTeams) => {
  if (Array.isArray(profileTeams)) {
    return profileTeams.reduce((total, team) => total + getOriginalTeamCount(team.id), 0);
  } else if (typeof profileTeams === 'object' && profileTeams !== null) {
    return Object.values(profileTeams).reduce((total, team) => total + getOriginalTeamCount(team.id), 0);
  } else {
    console.warn('profileTeams is neither an array nor an object:', profileTeams);
    return 0;
  }
};



const teamCount = computed(() => {
  const newTeamCount = {};
  Object.keys(teamsObj.value).forEach(teamId => {
    newTeamCount[teamId] = { originalCount: 0, filteredCount: 0 };
  });
  newTeamCount[''] = { originalCount: 0, filteredCount: 0 }; // For unassigned items

  items.value.forEach(item => {
    item.subItems.forEach(subItem => {
      const teamId = subItem.assigneeTeamId || '';
      newTeamCount[teamId].originalCount++;
    });
  });

  return newTeamCount;
});

const openAssignmentDialog = () => {
  showAssignmentDialog.value = true;
};

const hasAssignees = (item) => {
  return item.subItems.some(subItem => subItem.assigneeUserIds.length > 0);
};

const getUniqueAssigneeUserIds = (item) => {
  const assigneeUserIds = item.subItems.flatMap(subItem => subItem.assigneeUserIds);
  return [...new Set(assigneeUserIds)].slice(0, 5);
};


const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, 'yyyy-MM-dd');
};

const memoize = (fn) => {
  const cache = new Map();
  return (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn(...args);
    cache.set(key, result);
    return result;
  };
};

const getIconClass = memoize((icon) => {
  if (icon.startsWith('mdi-')) {
    return { icon: icon };
  } else if (icon.startsWith('fa-') || icon.startsWith('fas fa-') || icon.startsWith('fab fa-')) {
    return { icon: 'fa:' + icon };
  } else {
    return { icon: `md:${icon}` };
  }
});

const toggleExpand = (item) => {
  const index = expanded.value.indexOf(item.id)
  if (index === -1) {
    expanded.value.push(item.id)
  } else {
    expanded.value.splice(index, 1)
  }
}

const isExpanded = (item) => {
  return expanded.value.includes(item.id)
}

const expandIcon = computed(() => (item) => {
  return isExpanded(item) ? 'mdi-chevron-down' : 'mdi-chevron-right'
})

const { proxy } = getCurrentInstance();
const openUrl = (url) => {
  if (buildMode.value === 'production') {
    proxy.$launchUrl(url);
  } else {
    window.open(url, '_blank');
  }
};

/*watch(() => items.value, (newValue) => {
  if (newValue) {
    filterContext.value.updateItems(newValue);
  }
});*/

const setFirstTeamAsSelected = () => {
  const firstTeamId = Object.keys(props.assignableTeamIds)[0];
  if (firstTeamId) {
    selectedTeam.value = [firstTeamId];
    selectTeamInFilterContext(firstTeamId);
  } else {
    selectedTeam.value = [t('unAssigned')];
    selectTeamInFilterContext(t('unAssigned'));
  }
};

watch(() => props.assignableTeamIds, (newValue) => {
  if (Object.keys(newValue).length > 0) {
    setFirstTeamAsSelected();
  }
}, { immediate: true });

onMounted(() => {
  setFirstTeamAsSelected();
});


</script>

<style scoped>

.v-data-table .v-icon {
  opacity: 0.6;
}

.chart {
  height: 400px;
}
.v-list-group__items .v-list-item {
  padding-inline-start: 16px !important;
}



.client-id-cell {
  min-width: 200px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-data-table > .v-table__wrapper > table > tbody > tr > td {
        padding:0!important;
    }

    .mobile-data-table .v-card-title,
    .mobile-data-table .v-card-text
    {
        padding:5px 0!important;
    }


</style>